<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-12-30 20:01:42
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-26 15:31:53
-->
<template>
	<el-dialog
		class="share-dialog"
		width="480px"
		:visible.sync="dialogVisible"
		:append-to-body="true"
		show-close
		@close="resetForms()"
		:close-on-click-modal="false"
	>
		<template slot="title">
			<p>
				<span>修改{{ platformId | formatPlatformName('unify') }}</span>
			</p>
		</template>
		<el-form :inline="true" :model="formData" label-width="70px" ref="from" :rules="rules">
			<el-form-item :label="platformId | formatPlatformName('unify')" prop="anchor_account">
				<el-input v-model="formData.anchor_account" placeholder="请输入" maxlength="16" style="width: 360px"></el-input>
				<p class="fz-14 yx-color-text-primary">{{ text }}</p>
			</el-form-item>
		</el-form>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="submit">确认</el-button>
		</span>
	</el-dialog>
</template>
<script>
import throttle from 'lodash/throttle';
import { editTalent } from '@/api/talentCRM';
export default {
	name: 'modifyDyId',
	data() {
		return {
			dialogVisible: false,
			formData: {
				anchor_id: '',
				anchor_account: '',
				anchor_name: '',
				is_effective: '',
			},
			platformId: '1',
		};
	},
	computed: {
		rules() {
			return {
				anchor_account: [{ required: true, message: `请输入`, trigger: 'blur' }],
			};
		},
		text() {
			return this.$isDy() ? '不超过16个字母、数字、下划线和点' : '快手ID为纯数字，快手号仅支持8-20个字母、数字、下划线或减号，必须以字母开头';
		},
	},
	methods: {
		show(obj) {
			this.formData = { ...obj };
			this.platformId = obj.platform_id;
			this.dialogVisible = true;
		},
		resetForms() {
			this.$refs['from'].resetFields();
		},
		submit: throttle(function () {
			this.$refs.from.validate(async valid => {
				if (!valid) return;
				const {
					formData: { anchor_id, anchor_account, anchor_name, is_effective },
				} = this;
				const { code } = await editTalent({ anchor_id, anchor_account, anchor_name, is_effective });
				if (code !== 0) return;
				this.$message.success(`修改成功`);
				this.$emit('refresh');
				this.handleClose();
			});
		}, 1000),
		handleClose() {
			this.dialogVisible = false;
		},
	},
};
</script>